import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.948 5.373H3.058C1.37 5.373 0 6.715 0 8.366v12.641C0 22.658 1.371 24 3.057 24h18.886C23.629 24 25 22.658 25 21.007V8.371c.005-1.65-1.366-2.998-3.052-2.998m1.66 15.634c0 .897-.744 1.626-1.66 1.626H3.058c-.916 0-1.661-.73-1.661-1.626V8.371c0-.896.745-1.625 1.66-1.625h18.886c.916 0 1.66.729 1.66 1.625v12.636z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m15.769 14.53 6.114-5.368a.677.677 0 0 0 .052-.967.71.71 0 0 0-.988-.051l-8.432 7.41-1.645-1.439q-.009-.008-.01-.015a1 1 0 0 0-.114-.096L4.052 8.139a.71.71 0 0 0-.988.056.673.673 0 0 0 .057.967l6.187 5.414-6.16 5.647a.676.676 0 0 0-.032.967.708.708 0 0 0 .988.035l6.254-5.727 1.697 1.484a.71.71 0 0 0 .93-.005l1.744-1.53 6.218 5.784c.134.126.31.187.48.187.187 0 .368-.07.508-.213a.676.676 0 0 0-.026-.967z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M26.948 0H8.058C6.37 0 5 1.342 5 2.993v.679h1.397v-.674c0-.896.745-1.626 1.66-1.626h18.886c.916 0 1.66.73 1.66 1.626v12.636h.006c0 .896-.745 1.626-1.66 1.626h-.699v1.367h.693c1.687 0 3.057-1.342 3.057-2.993V2.998C30.006 1.348 28.635 0 26.948 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }